import { defineStore } from 'pinia';

export const useErrorStore = defineStore('error', {
  state: () => ({
    message: null
  }),
  actions: {
    process(error) {
      console.log(error);
      if (error.response) {
        const { useAuthStore } = require('./authentication.module');
        const { useAlertStore } = require('./alert.module');
        const authStore = useAuthStore();
        const alertStore = useAlertStore();
        switch (error.response.status) {
          case 401:
            authStore.logout();
            alertStore.error(error.response.data.message);
            break;
          case 403:
            authStore.logout();
            alertStore.error(error.response.message);
            break;
          case 404:
            alertStore.error(error.response.message);
            break;
          default:
            alertStore.error(error.response.data.message);
        }
        this.message = error.response.data.message;
      } else if (error == 'Error: Network Error') {
        this.message = error;
        const { useAlertStore } = require('./alert.module');
        useAlertStore().error('Нет связи с сервером');
      }
    }
  }
});
